import React, { useEffect, useRef } from 'react';
import { siteConfig } from '../data';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';

const Hero = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 1.0;
    }
  }, []);

  return (
    <section className="relative min-h-[100svh] md:h-[85vh] md:min-h-[800px] lg:h-[calc(100vh-80px)] lg:min-h-[600px] lg:mt-20 flex items-center overflow-hidden">
      {/* Background Video */}
      <div className="absolute inset-0 z-0">
        <video 
          ref={videoRef}
          autoPlay 
          loop 
          muted 
          playsInline 
          className="w-full h-full object-cover object-center block"
        >
          <source src="/video/gma_banner_video.mp4" type="video/mp4" />
        </video>
        {/* Overlay to ensure readability */}
        <div className="absolute inset-0 bg-black/30 md:hidden"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10 pt-20 md:pt-12 lg:pt-0">
        <motion.div 
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="w-full sm:w-fit max-w-full lg:max-w-[500px] bg-black/20 p-5 md:p-16 lg:p-8 rounded-2xl backdrop-blur-[2px] border border-white/10"
        >
          <h1 className="text-4xl md:text-7xl lg:text-4xl font-black text-white mb-6 lg:mb-4 leading-tight tracking-tighter uppercase">
            Sharing clean energy <br className="hidden md:block lg:hidden" />
            with the world
          </h1>
          <h2 className="text-xl md:text-2xl lg:text-base font-bold text-white mb-6 lg:mb-4 uppercase tracking-wider">
            {siteConfig.tagline}
          </h2>
          <p className="text-base md:text-lg lg:text-sm text-white mb-8 lg:mb-6 max-w-2xl leading-relaxed">
            {siteConfig.description}
          </p>
          <div className="flex flex-col sm:flex-row flex-wrap gap-4 lg:gap-3">
            <a 
              href="#contact" 
              className="w-full sm:w-auto justify-center bg-[#62b2c9] hover:bg-[#62b2c9]/90 text-white px-8 py-4 lg:px-5 lg:py-2.5 rounded-none font-black uppercase tracking-widest flex items-center gap-3 lg:gap-2 lg:text-xs transition-all transform hover:scale-105"
            >
              Kontakt os <ArrowRight className="w-5 h-5 lg:w-4 lg:h-4" />
            </a>
            <a 
              href="#products" 
              className="w-full sm:w-auto justify-center bg-transparent text-white px-8 py-4 lg:px-5 lg:py-2.5 rounded-none font-black uppercase tracking-widest border border-white hover:bg-white hover:text-black lg:text-xs transition-all transform hover:scale-105"
            >
              Se løsninger
            </a>
          </div>
        </motion.div>
      </div>

      {/* Decorative side element */}
      <div className="absolute right-0 bottom-0 top-0 w-1/4 hidden lg:block overflow-hidden pointer-events-none">
        <div className="absolute bottom-10 right-10 flex flex-col gap-4 text-white/50 text-xs uppercase tracking-widest">
            <div className="flex items-center gap-2">
                <div className="w-10 h-[1px] bg-white/30"></div>
                <span>Sustainable</span>
            </div>
            <div className="flex items-center gap-2">
                <div className="w-10 h-[1px] bg-white/30"></div>
                <span>Intelligent</span>
            </div>
            <div className="flex items-center gap-2">
                <div className="w-10 h-[1px] bg-white/30"></div>
                <span>Professional</span>
            </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
